import React, { useEffect, useRef, useState } from "react";
import { NavLink, useOutletContext } from "react-router-dom";
import {Elements, PaymentElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { baseUrl, appUrl } from "../../config.js";

import { estatus, formatoFecha, formatoMoneda } from "../../almacen.js";
import DashInoutsHost from "../Dashboards/DashInoutsHost.js";


import Modal from "../Modal/Modal";
import Cargando from '../../img/Cargando.gif';
import Tarjeta from '../../img/Tarjeta.png';
import Transferencia from '../../img/Transferencia.png';
import './Inout.css';
import useToken from "../../useToken.js";

const stripePromise = loadStripe('pk_test_mvWe2DA5Ez2FX37mx2FIaMd2003sG0WdPw');

const Inout = ()=>{

    const [id, setId] = useState(false) 

    return(
        <div className="inouts">
            {id !== false &&
                <Modal titulo={'In/Out'} setModal={setId}>
                    <Info id={id} setId={setId}/>
                </Modal>
            }
            <DashInoutsHost setId={setId}/>
        </div>
    )
}

const Info = ({reserva, id, setId})=>{

    const {token} = useToken();
    const [decide, setDecide] = useState(false);

    const [info, setInfo] = useState({});
    const [price, setPrice] = useState({subtotal:0, total:0});
    const [cantidad, setCantidad] = useState({in: '', out:''});
    const [clientSecret, setClientSecret] = useState('');
    const [cargando, setCargando] = useState(false);
    const [metodo, setMetodo] = useState('Transferencia');
    const [error, setError] = useState("");
    const [pagar, setPagar] = useState(false);
    const [confirmingPhysical, setConfirmingPhysical] = useState(false);
    const [layout, setLayout] = useState(null);
    const [asignaciones, setAsignaciones] = useState([]);

    useEffect(()=>{
        if(id && token){
            getData();
        }
    }, [token])

    const getData = async ()=>{
        const result1 = await fetch(baseUrl+"host/Inout/"+id, {
			headers:{
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		setInfo(result1?.data || {});
        setCantidad({
            in: result1?.data?.spacesIn || '',
            out: result1?.data?.spacesOut || '',
        })
    }

    const enviar = (action)=>{
        setCargando(true);
        const data = {
            idInout : id,
            date: info?.date,
            time: info?.time,
            action: action
        }
        fetch(baseUrl+"host/Inout", {
            method: "put",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        })
        .then(response=>response.json())
        .then(json=>{
            let status = action == 'Approve' ? 'Approved' : action == 'Decline' ? 'Canceled' : 'Pending';
            setInfo({...info, status, idInout: json?.id})
            setTimeout(() => {
                setId(false);
            }, 500);
        })
        .catch(error=>{
            setCargando(false);
            console.error(error);
        })
    }

    const startPhysicalConfirm = async () => {
        setConfirmingPhysical(true);
        if (cantidad.in > 0) {
            // Fetch layout to assign positions
            try {
                const res = await fetch(baseUrl + "my/store/" + info.idStore + "/layout", {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const json = await res.json();
                if (json.success) {
                    setLayout(json.data);
                    const initAsig = Array.from({length: cantidad.in}).map(() => ({ positionId: "" }));
                    setAsignaciones(initAsig);
                }
            } catch(e) {
                console.error(e);
            }
        }
    }

    const submitPhase = async (phase) => {
        setCargando(true);
        const data = {
            idInout: id,
            asignaciones: asignaciones,
            cantidadIn: cantidad.in,
            cantidadOut: cantidad.out
        };
        try {
            const res = await fetch(baseUrl + "host/Inout/" + id + "/" + phase, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });
            const json = await res.json();
            if (json.success) {
                // Determine new status optimistically based on phase
                let newStatus = 'Ended';
                if (phase === 'receive') newStatus = 'Received';
                if (phase === 'store') newStatus = info?.spacesOut > 0 ? 'Approved' : 'Ended';
                if (phase === 'prepare') newStatus = 'Prepared';
                
                setInfo({...info, status: newStatus});
                if (newStatus === 'Ended') {
                    setTimeout(() => setId(false), 500);
                } else {
                    setConfirmingPhysical(false);
                }
            } else {
                console.error(json.error);
            }
        } catch(e) {
            console.error(e);
        }
        setCargando(false);
    }

    const defaultFecha = info?.date ? formatoFecha(new Date(info?.date?.split("T")[0].split("-"))) : "";
    const statusKey = info?.status || 'Waiting';
    const horaCorta = (info?.time || '').toString().slice(0, 5);

    return(
        <div className="infoInout infoInout--host">
            {info?.status &&
                <div className="divEstatus">
                    <span className={`booking-status booking-status--${statusKey}`}>
                        {estatus[info?.status]}
                    </span>
                </div>
            }
            {confirmingPhysical ? (
                <div className="formInout physicalConfirm">
                    <h3>Confirmar Operación Física</h3>
                    {info?.spacesIn > 0 && info?.status === 'Approved' && (
                        <div>
                            <h4>Validar Recepción</h4>
                            <label className="inputInout" style={{display: 'inline-block', marginBottom: 15}}>
                                <span>Cantidad Real que Ingresa:</span>
                                <input type="number" value={cantidad.in} min={0} onChange={(e)=>{
                                    const val = Math.max(0, parseInt(e.target.value) || 0);
                                    setCantidad({...cantidad, in: val});
                                }} style={{width: 80, marginLeft: 10}}/>
                            </label>
                            <div className="botonesInout">
                                <button type="button" className="btn black" onClick={() => submitPhase('receive')} disabled={cargando}>
                                    Confirmar Recibo
                                </button>
                                <button type="button" className="btn cancelar" onClick={() => setConfirmingPhysical(false)}>Cancelar</button>
                            </div>
                        </div>
                    )}
                    {info?.spacesIn > 0 && info?.status === 'Received' && (
                        <div>
                            <h4>Asignar Posiciones de Recepción</h4>
                            {asignaciones.map((asig, i) => (
                                <div key={i} className="inputInout" style={{marginTop: 10}}>
                                    <label>
                                        <select value={asig.positionId} onChange={(e) => {
                                            const newAsig = [...asignaciones];
                                            newAsig[i].positionId = e.target.value;
                                            setAsignaciones(newAsig);
                                        }}>
                                            <option value="">Seleccionar Posición...</option>
                                            {layout?.grid?.cells?.filter(c => !c.occupied && !c.mine).map(cell => (
                                                <option key={cell.id} value={cell.id}>{cell.name}</option>
                                            ))}
                                            {layout?.levels?.map(lvl => (
                                                <optgroup key={lvl.name} label={lvl.name}>
                                                    {lvl.positions.filter(p => !p.occupied && !p.mine).map(pos => (
                                                        <option key={pos.id} value={pos.id}>{pos.name}</option>
                                                    ))}
                                                </optgroup>
                                            ))}
                                        </select>
                                        <span>Pallet {i + 1}</span>
                                    </label>
                                </div>
                            ))}
                            <div className="botonesInout" style={{marginTop: 20}}>
                                <button type="button" className="btn black" onClick={() => submitPhase('store')} disabled={cargando}>
                                    Confirmar Almacenamiento
                                </button>
                                <button type="button" className="btn cancelar" onClick={() => setConfirmingPhysical(false)}>Cancelar</button>
                            </div>
                        </div>
                    )}
                    {info?.spacesOut > 0 && info?.status === 'Approved' && (
                        <div style={{marginTop: 20}}>
                            <h4>Confirmar Preparación (Picking)</h4>
                            <p>Verifica que los pallets hayan sido preparados.</p>
                            <div className="botonesInout">
                                <button type="button" className="btn black" onClick={() => submitPhase('prepare')} disabled={cargando}>
                                    Confirmar Preparación
                                </button>
                                <button type="button" className="btn cancelar" onClick={() => setConfirmingPhysical(false)}>Cancelar</button>
                            </div>
                        </div>
                    )}
                    {info?.spacesOut > 0 && info?.status === 'Prepared' && (
                        <div style={{marginTop: 20}}>
                            <h4>Confirmar Salida / Entrega</h4>
                            <label className="inputInout" style={{display: 'inline-block', marginBottom: 15}}>
                                <span>Cantidad Real que Sale:</span>
                                <input type="number" value={cantidad.out} min={0} onChange={(e)=>{
                                    const val = Math.max(0, parseInt(e.target.value) || 0);
                                    setCantidad({...cantidad, out: val});
                                }} style={{width: 80, marginLeft: 10}}/>
                            </label>
                            <p>Verifica que los pallets hayan sido cargados.</p>
                            <div className="botonesInout">
                                <button type="button" className="btn black" onClick={() => submitPhase('deliver')} disabled={cargando}>
                                    Confirmar Entrega
                                </button>
                                <button type="button" className="btn cancelar" onClick={() => setConfirmingPhysical(false)}>Cancelar</button>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="inoutHostCard">
                    {(info?.status === 'Waiting' || info?.status === 'WaitingClient') ? (
                        <>
                            <div className="inoutHostCard__head">
                                <h3>¿Aprobar esta solicitud de In/Out?</h3>
                                <p>Confirma la operación o propone otro horario al cliente.</p>
                            </div>

                            <div className="inoutHostChoice" role="group" aria-label="Decisión">
                                <button
                                    type="button"
                                    className={'inoutHostChoice__btn' + (decide === 'Approve' ? ' is-active is-approve' : '')}
                                    onClick={()=> setDecide('Approve')}
                                >
                                    Aprobar
                                </button>
                                <button
                                    type="button"
                                    className={'inoutHostChoice__btn' + (decide === 'Decline' ? ' is-active is-suggest' : '')}
                                    onClick={()=> setDecide('Decline')}
                                >
                                    Proponer cambio
                                </button>
                            </div>

                            {decide === 'Decline' &&
                                <div className="inoutHostHint">
                                    Ajusta fecha u hora y envía la sugerencia, o rechaza la solicitud por completo.
                                </div>
                            }
                        </>
                    ) : (
                        <div className="inoutHostCard__head">
                            <h3>Detalles de la Reservación</h3>
                            <p>Horario y espacios solicitados por el cliente.</p>
                        </div>
                    )}

                    <form className="formInout" onSubmit={(e)=> e.preventDefault()}>
                        <section className="inoutHostBlock">
                            <h4>Horario</h4>
                            <div className="inoutHostFields">
                                <label className="inoutHostField">
                                    <span>Fecha</span>
                                    <input
                                        type="date"
                                        readOnly={info?.status === 'Approved' || decide !== 'Decline'}
                                        defaultValue={defaultFecha}
                                        min={formatoFecha(new Date())}
                                        onChange={(e)=>{ info.date = e.target.value; }}
                                    />
                                </label>
                                <label className="inoutHostField">
                                    <span>Hora</span>
                                    <input
                                        type="time"
                                        readOnly={info?.status === 'Approved' || decide !== 'Decline'}
                                        defaultValue={horaCorta}
                                        onChange={(e)=>{ info.time = e.target.value; }}
                                    />
                                </label>
                            </div>
                        </section>

                        <section className="inoutHostBlock">
                            <h4>Pallet positions</h4>
                            <div className="inoutHostMetrics">
                                {cantidad.in > 0 && (
                                    <div className="inoutHostMetric">
                                        <span>In</span>
                                        <strong>{cantidad.in}</strong>
                                    </div>
                                )}
                                {cantidad.out > 0 && (
                                    <div className="inoutHostMetric">
                                        <span>Out</span>
                                        <strong>{cantidad.out}</strong>
                                    </div>
                                )}
                            </div>
                        </section>

                        {info?.products?.length > 0 && (
                            <section className="inoutHostBlock">
                                <h4>Productos Solicitados</h4>
                                <ul className="listaProductos" style={{marginTop: 10, paddingLeft: 0, listStyle: 'none'}}>
                                    {info.products.map((p, i) => {
                                        const prodName = info.clientProducts?.find(x => x.id == p.productId)?.name || 'Producto '+p.productId;
                                        return (
                                            <li key={i} style={{marginBottom: 5}}>
                                                <b>{p.qty}x</b> {prodName} <i>({p.direction === 'in' ? 'Entrada' : 'Salida'})</i>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </section>
                        )}
                    </form>

                    <div className="inoutHostActions">
                        {['Approved', 'Received', 'Prepared'].includes(info?.status) ? (
                            <button
                                type="button"
                                className="inoutHostActions__primary"
                                onClick={startPhysicalConfirm}
                                style={{background: '#0a0a0a', color: 'white'}}
                            >
                                {info?.status === 'Approved' && info?.spacesIn > 0 ? 'Registrar Recibo' :
                                 info?.status === 'Received' ? 'Asignar Almacenamiento' :
                                 info?.status === 'Approved' && info?.spacesOut > 0 ? 'Registrar Preparación' :
                                 info?.status === 'Prepared' ? 'Registrar Salida' : 'Registrar'}
                            </button>
                        ) : (
                            <>
                                {decide === 'Approve' &&
                                    <button
                                        type="button"
                                        className="inoutHostActions__primary"
                                        disabled={cargando}
                                        onClick={()=> enviar('Approve')}
                                    >
                                        {cargando ? 'Confirmando…' : 'Confirmar In/Out'}
                                    </button>
                                }

                                {decide === 'Decline' &&
                                    <>
                                        <button
                                            type="button"
                                            className="inoutHostActions__primary"
                                            disabled={cargando}
                                            onClick={()=> enviar('Suggest')}
                                        >
                                            {cargando ? 'Enviando…' : 'Enviar sugerencia'}
                                        </button>
                                        <button
                                            type="button"
                                            className="inoutHostActions__danger"
                                            disabled={cargando}
                                            onClick={()=> enviar('Decline')}
                                        >
                                            Rechazar
                                        </button>
                                    </>
                                }

                                {!decide &&
                                    <p className="inoutHostActions__idle">Elige aprobar o proponer un cambio para continuar.</p>
                                }
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

const CheckoutForm = ({id, idBooking}) => {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
        // Stripe.js hasn't yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
        }

        const {error} = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
            return_url: appUrl+'reservaciones/'+idBooking+'/inout',
        },
        });


        if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
        } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
        }
    };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button className="btn continuar" disabled={!stripe}>Continuar</button>
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  )
};

export default Inout;